import { jsx as a, Fragment as N, jsxs as s } from "react/jsx-runtime";
import e from "./styles.module.less.js";
import A from "./logo.webp.js";
import S from "./menu-dropdown-wrapper-mobile.svg.js";
import G from "./burger.svg.js";
import H from "./close.svg2.js";
import { useState as I, useCallback as m, useMemo as x } from "react";
import { AccountLink as U } from "./account-link/index.js";
import O from "./chevron-right.svg.js";
import { DropdownMenuItemMobile as D } from "./dropdown-menu-item/index.js";
import { useDisableScroll as R } from "../../../utils/use-disable-scroll.js";
import { areasOfLawData as T } from "../../../constants.js";
import { convertToKebabCase as q } from "../../../utils/case-conversion.js";
import { MobileAccountModalLink as B } from "./mobile-account-modal/index.js";
import { ForLawyersMenuButtonMobile as W } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemMobile as y } from "./get-help-menu-item/index.js";
import { GradientButton as j } from "./gradient-button/index.js";
import { MenuChatButtonMobile as E } from "./chat-button/index.js";
import F from "./chevron-right-gradient.svg.js";
const me = (t) => {
  const {
    isAuthenticated: c,
    openAuthModal: n,
    getTranslation: r,
    language: p,
    useWill: i,
    lmpEnabled: M,
    onRequestLawyer: d,
    hideLinks: C
  } = t, [o, l] = I(!1);
  R({ isDisabled: o });
  const u = m(() => {
    l(!0);
  }, []), h = m(() => {
    l(!1);
  }, []), g = m(() => {
    l(!1), c || n();
  }, [c, n]), f = m(() => {
    l(!1), t.logout();
  }, [t.logout]);
  return /* @__PURE__ */ a(N, { children: /* @__PURE__ */ s(
    "div",
    {
      className: `${e.menuModalOverlay} ${o ? e.menuModalOverlayOpen : ""}`,
      children: [
        /* @__PURE__ */ a(
          K,
          {
            isMenuOpen: o,
            closeMenu: h,
            openMenu: u,
            onAccountClick: g,
            handleLogout: f,
            isAuthenticated: t.isAuthenticated,
            userImage: t.userImage,
            hasNotifications: t.hasNotifications,
            language: p,
            getTranslation: r,
            isLawyerSupported: t.isLawyerSupported,
            onRequestLawyer: d,
            hideLinks: C,
            useWill: i,
            newChatUrl: t.newChatUrl
          }
        ),
        !C && /* @__PURE__ */ s(N, { children: [
          /* @__PURE__ */ a(
            z,
            {
              isAuthenticated: t.isAuthenticated,
              language: p,
              handleLogout: f,
              closeMenu: h,
              hasNotifications: t.hasNotifications,
              userImage: t.userImage,
              onAccountClick: g,
              getTranslation: r,
              isLawyerSupported: t.isLawyerSupported,
              onRequestLawyer: d,
              lmpEnabled: M,
              environment: t.environment,
              legalHubSupported: t.legalHubSupported,
              newChatUrl: t.newChatUrl
            }
          ),
          /* @__PURE__ */ a(S, { className: e.mobileBGIcon })
        ] })
      ]
    }
  ) });
}, K = (t) => {
  const {
    isMenuOpen: c,
    closeMenu: n,
    openMenu: r,
    onAccountClick: p,
    handleLogout: i,
    isAuthenticated: M,
    hasNotifications: d,
    userImage: C,
    language: o,
    getTranslation: l,
    isLawyerSupported: u,
    onRequestLawyer: h,
    hideLinks: g
  } = t, [f, w] = I(!1), L = m(() => {
    w(!0);
  }, []), b = m(() => {
    w(!1);
  }, []);
  return /* @__PURE__ */ s("div", { className: e.mobileMenuContainer, children: [
    !g && /* @__PURE__ */ a(
      "div",
      {
        className: e.menuIconContainer,
        onClick: c ? n : r,
        children: /* @__PURE__ */ s("div", { className: e.iconWrapper, children: [
          /* @__PURE__ */ a(
            "img",
            {
              src: G,
              alt: "hamburger",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.defaultIcon} ${c ? e.hidden : ""}`
            }
          ),
          /* @__PURE__ */ a(
            "img",
            {
              src: H,
              alt: "close",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.activeIcon} ${c ? "" : e.hidden}`
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ a(
      "a",
      {
        href: o ? `/${o}` : "/",
        className: e.logoContainer,
        children: /* @__PURE__ */ a(
          "img",
          {
            src: A,
            alt: "logo",
            width: 130,
            height: 18,
            className: e.logo
          }
        )
      }
    ),
    !g && (M ? /* @__PURE__ */ a(
      U,
      {
        isAuthenticated: M,
        userImage: C,
        openAuthModal: p,
        logout: i,
        hasNotifications: d,
        closeMenuModal: n,
        language: o,
        getTranslation: l,
        newChatUrl: t.newChatUrl
      }
    ) : o === "en-au" ? /* @__PURE__ */ s(N, { children: [
      /* @__PURE__ */ a(
        j,
        {
          label: l("pages.get-help"),
          onClick: L,
          className: e.mobileMenuGradientButton
        }
      ),
      /* @__PURE__ */ a(
        y,
        {
          language: o || "en",
          titleLabel: l("pages.get-help"),
          getTranslation: l,
          isLawyerSupported: u,
          onRequestLawyer: h,
          newChatUrl: t.newChatUrl,
          closeMenu: b,
          externalIsOpen: f,
          externalOnOpen: L,
          externalOnClose: b,
          hideDefaultTrigger: !0
        }
      )
    ] }) : /* @__PURE__ */ a(
      E,
      {
        getTranslation: l,
        language: o,
        newChatUrl: t.newChatUrl
      }
    ))
  ] });
}, z = (t) => {
  const {
    handleLogout: c,
    language: n,
    closeMenu: r,
    onAccountClick: p,
    getTranslation: i,
    isLawyerSupported: M,
    lmpEnabled: d,
    onRequestLawyer: C,
    useWill: o,
    environment: l,
    legalHubSupported: u = !1,
    newChatUrl: h
  } = t, [g, f] = I(!1), w = m(() => {
    f(!0);
  }, []), L = m(() => {
    f(!1);
  }, []), b = x(() => {
    var v;
    const $ = (v = T[n]) == null ? void 0 : v.map((k) => ({
      ...k,
      path: `/${n}/${u ? "legal-hub" : "topics"}/${k.link ?? q(k.title)}`
    }));
    return $ || null;
  }, [n, u]);
  return /* @__PURE__ */ s("div", { className: e.menuModalContent, children: [
    n === "en-au" && /* @__PURE__ */ s("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      /* @__PURE__ */ s(
        "div",
        {
          className: `${e.mainMenuLink} ${e.gradientText}`,
          onClick: w,
          children: [
            /* @__PURE__ */ a("div", { className: e.gradientTextContent, children: i("pages.get-help") }),
            /* @__PURE__ */ a(F, { className: `${e.arrowIcon}` })
          ]
        }
      ),
      /* @__PURE__ */ a(
        y,
        {
          language: n,
          titleLabel: i("pages.get-help"),
          getTranslation: i,
          isLawyerSupported: M,
          onRequestLawyer: C,
          newChatUrl: h,
          closeMenu: L,
          externalIsOpen: g,
          externalOnOpen: w,
          externalOnClose: L,
          hideDefaultTrigger: !0
        }
      )
    ] }),
    /* @__PURE__ */ s("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      d ? /* @__PURE__ */ s("a", { href: n ? `/${n}/find` : "/find", className: e.mainMenuLink, onClick: r, children: [
        "Browse lawyers",
        /* @__PURE__ */ a(O, { className: e.arrowIcon })
      ] }) : null,
      b && /* @__PURE__ */ a(
        D,
        {
          language: n,
          titleLabel: u ? "Legal hub" : i("pages.legal-topics"),
          link: `/${n}/${u ? "legal-hub" : "topics"}`,
          items: b,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      d ? null : /* @__PURE__ */ a(
        "a",
        {
          href: `/${n}/about/company`,
          className: e.mainMenuLink,
          onClick: r,
          children: i("pages.about")
        }
      ),
      /* @__PURE__ */ a(
        W,
        {
          language: n,
          getTranslation: i,
          useWill: o,
          environment: l,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      t.isAuthenticated ? /* @__PURE__ */ a(
        B,
        {
          language: n,
          handleLogout: c,
          userImage: t.userImage,
          hasNotifications: t.hasNotifications,
          getTranslation: i,
          newChatUrl: h
        }
      ) : /* @__PURE__ */ s("div", { className: e.mainMenuLink, onClick: p, children: [
        i("pages.account"),
        /* @__PURE__ */ a(O, { className: e.arrowIcon })
      ] })
    ] }),
    /* @__PURE__ */ s("div", { className: e.menuLinksContainer, children: [
      n.includes("en") && /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/insights` : "/insights",
          className: e.subMenuLink,
          onClick: r,
          children: i("pages.insights")
        }
      ),
      /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/faqs` : "/faqs",
          className: e.subMenuLink,
          onClick: r,
          children: i("pages.faqs")
        }
      ),
      b && /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/directory` : "/directory",
          className: e.subMenuLink,
          onClick: r,
          children: "Case study directory"
        }
      ),
      /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/contact-us` : "/contact-us",
          className: e.subMenuLink,
          onClick: r,
          children: i("pages.contact-us")
        }
      )
    ] })
  ] });
};
export {
  me as MobileMenu
};
